import { gql } from "@apollo/client";

export const REMOVE_HASHTAG_FROM_FEED = gql`
  mutation removeHashtagFromFeed($removeHashtagFromFeedInput: RemoveHashtagFromFeedInput!) {
    removeHashtagFromFeed(removeHashtagFromFeedInput: $removeHashtagFromFeedInput) {
      id
    }
  }
`;
